import {html, LitElement} from "lit";
import {customElement} from "lit/decorators.js";
import styles from "./ToggleButtonProQuest.styles.js";
import {renderPowerNotesLogo} from "../../common/powerNotesLogo.js";

@customElement("pn-toggle-button-proquest")
export class ToggleButtonProQuest extends LitElement {
	static styles = [styles];

	render() {
		const isPdf = window?.PDFViewerApplication !== undefined;

		return html`
			<button aria-label="Toggle PowerNotes sidebar" class="${isPdf ? "is-pdf" : ""}">
				${renderPowerNotesLogo()}
				<span>${!isPdf ? "Research with PowerNotes" : "PowerNotes"}</span>
			</button>
		`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		"pn-toggle-button-proquest": ToggleButtonProQuest;
	}

	interface Window {
		PDFViewerApplication?: any;
	}
}
